const splitStringBySpace = string => string.split(' ');
const amountFormat = num => num && num.toFixed(2);

export { splitStringBySpace, amountFormat };
